module.exports = __webpack_public_path__ + "img/team-3.329c7249.jpg";